export function isEditorjsContent(version: string | null) {
  // With future version, we may need to be more accurate.
  return !!version;
}
